import type { Router } from 'vue-router'
import { useUserStore } from '@/store/modules/user'
import { registerRoutes, resetRouter } from '../utils'
import { message } from 'ant-design-vue'

let isRegisterRoute = false
// 注册路由
async function registerRoutesIfNeeded() {
  if (!isRegisterRoute) {
    const userStore = useUserStore()
    const permissions = await userStore.getUserActions()
    registerRoutes(permissions)
    isRegisterRoute = true
  }
}
// 重置路由
function resetRoutesIfNeeded() {
  if (isRegisterRoute) {
    resetRouter()
    isRegisterRoute = false
  }
}

const redirectToLogin = (goto: string) => ({ name: 'login', query: { goto }, replace: true })

const redirectToErrorPage = (tip: string) => ({ name: '500', query: { tip } })

// const redirectTo403Page = () => ({ name: '403', query: { tip: '没有任何租户权限' } })

/**
 * 页面访问权限逻辑
 */
export function setupAuthHook(router: Router) {
  // 最新跳转的路由
  let latestRouteName: string
  router.beforeEach(async (to) => {
    latestRouteName = to.name as string
    const userStore = useUserStore()
    const isLogined = !!userStore.userInfo
    const isNeedLogin = to.meta.isNeedLogin !== false

    // 需要登录但未登录
    if (isNeedLogin && !isLogined) {
      resetRoutesIfNeeded()
      return redirectToLogin(to.fullPath)
    }

    // 去无需登录页面
    if (isRegisterRoute && !isNeedLogin) {
      resetRoutesIfNeeded()
      return true
    }

    // 访问到未注册的路由
    if (!isRegisterRoute && to.name === '404' && to.path !== '/404') {
      try {
        await registerRoutesIfNeeded()
        return { path: to.path, query: to.query }
      } catch (err) {
        message.error(err.message)
        // 如果不是因为未登录的错误
        if (latestRouteName !== 'login') {
          return redirectToErrorPage(err.message)
        }
      }
    }

    // 从不需登录的页面到登录的页面
    // const isNeedCheck = isNeedLogin && (!from.name || from.meta.isNeedLogin === false)
    // if (isNeedCheck) {
    // }
  })
}
